export const buildNumber = '20260826.2';
export const version = 'main';
export const latestCommit = '1d8126c6cd8cc30b7e4fb4b245acf1645ac6fb37';
